var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenuCourses = function SvgMenuCourses(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#menu-courses_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.284 4.4C3.25 5.823 3.25 7.854 3.25 11.917v2.166c0 4.062 0 6.094 1.034 7.518.335.46.739.864 1.199 1.198 1.424 1.034 3.455 1.034 7.517 1.034s6.093 0 7.517-1.034c.46-.334.864-.739 1.198-1.198 1.035-1.424 1.035-3.456 1.035-7.518v-2.166c0-4.063 0-6.094-1.035-7.517A5.4 5.4 0 0 0 20.518 3.2C19.093 2.167 17.062 2.167 13 2.167s-6.093 0-7.517 1.034c-.46.334-.864.739-1.199 1.198",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#menu-courses_svg__b)",
    fillRule: "evenodd",
    d: "M8.666 7.854a.812.812 0 1 0 0 1.625h8.667a.813.813 0 0 0 0-1.625zm0 4.334a.813.813 0 0 0 0 1.624h8.667a.813.813 0 0 0 0-1.624zm0 4.333a.813.813 0 0 0 0 1.625h8.667a.812.812 0 1 0 0-1.625z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "menu-courses_svg__b",
    x1: 13.086,
    x2: 27.29,
    y1: 20.338,
    y2: 6.415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("filter", {
    id: "menu-courses_svg__a",
    width: 67.5,
    height: 69.667,
    x: -20.75,
    y: -21.833,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_56_4326"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_56_4326",
    result: "shape"
  })))));
};
export { SvgMenuCourses as ReactComponent };